import React, { useState, useEffect } from "react";
import { ShieldCheck, X } from "lucide-react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "blackbear_cookie_ack";
const COOKIE_REJECTED_KEY = "blackbear_cookie_rejected";

const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY) && !localStorage.getItem(COOKIE_REJECTED_KEY)) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, "1");
    setOpen(false);
    if (window.clarity) window.clarity("consent");
  };

  const handleReject = () => {
    localStorage.setItem(COOKIE_REJECTED_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 z-[1000] w-full flex justify-center pointer-events-none">
      <div
        className="
          w-full max-w-4xl
          bg-white/95 dark:bg-slate-800/95
          border border-gray-200 dark:border-slate-700
          shadow-2xl rounded-2xl
          flex flex-col sm:flex-row items-center gap-4 sm:gap-6
          px-4 sm:px-8 py-4
          mb-4
          pointer-events-auto
          backdrop-blur
          transition-all
        "
        role="alert"
        aria-live="polite"
      >
        <div className="flex-shrink-0 mb-2 sm:mb-0">
          <ShieldCheck className="text-blue-600 dark:text-blue-400" size={32} />
        </div>
        <div className="flex-1 text-[15px] text-gray-700 dark:text-gray-200 leading-relaxed">
          <span className="font-semibold">We value your privacy.</span>{" "}
          To improve your experience, we use cookies and analytics to track site usage
          and collect information when you submit forms on our site (including Microsoft Forms).
          By using this site, you agree to our{" "}
          <Link
            to="/privacy"
            className="text-blue-700 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300"
            tabIndex={0}
          >
            Privacy Policy
          </Link>
          .
        </div>
        <div className="flex gap-2 mt-3 sm:mt-0">
          <button
            onClick={handleAccept}
            className="inline-flex items-center px-4 py-2 rounded-lg bg-blue-700 hover:bg-blue-800 text-white text-sm font-semibold shadow focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
          >
            Accept
          </button>
          <button
            onClick={handleReject}
            className="inline-flex items-center px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-slate-700 dark:hover:bg-slate-600 dark:text-gray-200 text-sm font-semibold shadow focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
          >
            Reject
          </button>
          <button
            aria-label="Dismiss"
            onClick={() => setOpen(false)}
            className="ml-2 p-2 rounded-lg text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 focus:outline-none transition"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
